module.exports = __webpack_public_path__ + "img/Doc.159c051a.svg";